export default {
  projectDesc: 'A <strong>Vue2</strong> plugin for input content suggestions, support keyboard to quick pick',
  demo: {
    singleColumn: 'Data column match mode',
    custom: 'Customize suggestions using the "showField" of the function type',
    placeholder: 'The short hint is displayed when no content is entered',
    disabled: 'Disabled plugin',
    slot: 'Use scoped slot to customize suggestions',
    limit: 'Limit the number of suggestion results list (5 for example)',
    raw: 'Respond to the item selected event and output the selected item raw data'
  },
  option: {
    data: 'the input content suggestions data source set',
    keyField: 'specified the field as key field',
    showField: 'string type to specified content field. also can set function type to custom row content',
    limit: 'Limit the number of suggestion results list, set 0 for unlimited'
  },
  event: {
    values: 'output the selected item raw data'
  }
}
